<template>
  <div>
    <div class="page-body mt-4">
      <data-card class="data-card" type="orderBuy" :loading="loading">
        <b-row no-gutters class="mb-1">
          <b-col>
            <h3 class="tickets-header">لیست تیکت ها</h3>
          </b-col>
          <!-- <b-col class="text-left">
            <button @click="modalShow = !modalShow" class="btn primary-button">
              ثبت تیکت جدید
            </button>
          </b-col> -->
        </b-row>

        <AllTickets
          :key="ticketsKey"
          :departments="departments"
          :priorities="priorities"
        />

        <b-modal size="lg" hide-header hide-footer centered v-model="modalShow">
          <template #default="{ hide }">
            <h3 class="modal-header">ثبت تیکت</h3>
            <p class="modal-text">
              برای دریافت پشتیبانی متن خود را در زیر وارد کنید. برای تیکت خود یک
              عنوان انتخاب کنید
            </p>

            <validation-observer v-slot="{ invalid }" ref="formValidator">
              <b-form class="card-input-form text-right" role="form">
                <b-row>
                  <b-col cols="12" md="6">
                    <div class="select_wrap">
                      <label class="form-label">دپارتمان</label>
                      <v-select
                        :components="{ Deselect }"
                        :options="departments"
                        dir="rtl"
                        label="title"
                        class="style-chooser"
                        v-model="selectedDepartment"
                      >
                        <div slot="no-options">موردی یافت نشد</div>
                        <template #search="{ attributes, events }">
                          <input
                            class="vs__search"
                            :required="!selectedDepartment"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-select>
                    </div>
                  </b-col>

                  <b-col>
                    <div class="select_wrap">
                      <label class="form-label">اولویت</label>
                      <v-select
                        :components="{ Deselect }"
                        :options="priorities"
                        label="title"
                        dir="rtl"
                        class="style-chooser"
                        v-model="selectedPriority"
                      >
                        <div slot="no-options">موردی یافت نشد</div>
                        <template #search="{ attributes, events }">
                          <input
                            class="vs__search"
                            :required="!selectedPriority"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-select>
                    </div>
                  </b-col>
                </b-row>
                <b-row no-gutters class="mt-3">
                  <b-col sm="12">
                    <label class="form-label">عنوان پیغام</label>

                    <b-form-group>
                      <base-input
                        placeholder="عنوان پیغام"
                        type="text"
                        class="text-input"
                        :rules="{ required: true }"
                        name="عنوان پیغام"
                        v-model="subject"
                      ></base-input>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row no-gutters class="mt-3">
                  <b-col sm="12">
                    <label class="form-label">متن پیغام</label>

                    <b-form-group>
                      <b-form-textarea
                        placeholder="متن پیغام"
                        type="text"
                        class="text-input"
                        :state="messageState"
                        name="متن پیغام"
                        rows="4"
                        v-model="message"
                      ></b-form-textarea>

                      <div
                        v-if="message.length <= 2"
                        class="invalid-feedback"
                        style="display: block"
                      >
                        عنوان پیغام الزامی است
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row class="mb-4 mt-2">
                  <b-col>
                    <b-form-file
                      v-model="attached"
                      ref="file"
                      type="file"
                      id="file"
                      @input="changeFile()"
                      placeholder="یک فایل انتخاب کنید"
                      drop-placeholder="فایل را در اینجا بیاندازید"
                    ></b-form-file>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col no-gutters class="pr-3 button-container">
                    <b-button
                      type="button"
                      :disabled="invalid || !messageState"
                      class="submit-button"
                      @click="submitForm()"
                      >ثبت</b-button
                    >
                    <button
                      type="button"
                      class="btn cancel-button"
                      data-dismiss="modal"
                      @click="hide()"
                    >
                      انصراف
                    </button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </template>
        </b-modal>

        <!-- <validation-observer v-slot="{ invalid }" ref="formValidator">
          <b-form class="card-input-form text-right" role="form"> 
            <b-row></b-row>


          </b-form>
        </validation-observer> -->
      </data-card>
    </div>
  </div>
</template>
<script>
import DataCard from "@/components/Cards/DataCard";
import AllTickets from "./AllTickets.vue";
import axios from "axios";

// Components

export default {
  name: "Tickets",
  components: {
    DataCard,
    AllTickets,
  },
  data() {
    return {
      Deselect: {
        render: (createElement) => createElement("span", ""),
      },
      title: "لیست تیکت ها",
      guidanceItemsTitle: "راهنمای احراز هویت ",
      guidanceItems:
        "در هنگام خرید فقط مجاز به پرداخت با کارت‌های تایید شده در سایت می‌باشید،در غیر این‌صورت وجه پرداختی به صورت اتوماتیک به کارت واریزی عودت داده خواهد شد شماره کیف پول دلاری وب‌مانی با حرف Z آغاز می‌شود",
      types: [],
      loading: false,

      subject: "",
      message: "",
      departments: [],
      selectedDepartment: "",

      attached: null,

      ticketsKey: 1,

      priorities: [
        { id: "1", title: "کم" },
        { id: "2", title: "متوسط" },
        { id: "3", title: "زیاد" },
      ],
      selectedPriority: { id: "1", title: "کم" },

      modalShow: false,
    };
  },

  computed: {
    messageState() {
      return this.message.length > 2 ? true : false;
    },
  },

  mounted() {
    this.getDepartments();
  },

  methods: {
    changeFile() {
      // this.file = this.$refs.file.files[0];
    },

    submitForm() {
      this.invalid = true;

      let data = {
        department: this.selectedDepartment.uid,
        priority: this.selectedPriority.id,
        subject: this.subject,
        message: this.message,
        attached: this.attached,
      };

      this.$store
        .dispatch("createTicket", data)
        .then((res) => {
          console.log(res);

          this.$swal({
            position: "center",
            icon: "success",
            title: "تیکت با موفقیت ثبت شد",
            showConfirmButton: false,
            timer: 1500,
          });

          this.modalShow = false;
          this.ticketsKey++;

          this.loading = false;
        })
        .catch((err) => {
          this.loading = true;
          this.$swal({
            position: "center",
            icon: "error",
            title: "خطا در ثبت اطلاعات",
            showConfirmButton: false,
            timer: 1500,
          });

          let errorResponse = this.errorHandler(err);
        });
    },

    getDepartments() {
      // this.loading = true;
      axios({
        method: "get",
        url: process.env.VUE_APP_TICKETSERVICE_URL + "/api/departments/list",
        //baseURL: process.env.VUE_APP_BASE_URL,
        crossDomain: true,
        headers: {
          //'Access-Control-Allow-Origin': '*',
          Authorization: "Bearer " + this.$store.getters.token,
        },
      })
        .then((response) => {
          this.departments = response.data.list;
          this.selectedDepartment = this.departments[0];
          this.selectedPriority = this.priorities[0];

          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          let errorResponse = this.errorHandler(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.submit-button {
  padding: 8px 40px;
  height: 36px;
  // margin-bottom: 24px;
  margin: 0;
  border-radius: 4px;
  background-color: #2a6ae3;
  color: #fff;
}

@media (max-width: 991px) {
  .submit-button {
    width: 100%;
    padding: 8px 40px;
    height: 46px;
  }

  .cancel-button {
    width: 100%;
    height: 46px;
    margin-top: 4px;
    margin-bottom: 4px;
  }
}

.modal-header {
  padding: 0;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #212121;
}

.custom-file {
  text-align: center;
}
</style>
